import { provideTransloco, TranslocoModule, TranslocoService } from '@jsverse/transloco'
import { APP_INITIALIZER, NgModule } from '@angular/core'
import { firstValueFrom } from 'rxjs'
import { TranslocoHttpLoader } from './transloco-loader'
import { environment } from 'src/environments/environment'
import { tenantConfig } from '@env/tenant'

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['en', 'fr'],
        // Default language is tenant-driven (canada_env → 'en', quebec_env → 'fr').
        // This is what the login page uses, before any user preference is known.
        defaultLang: tenantConfig.locale.default_language,
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: environment.production,
      },
      loader: TranslocoHttpLoader,
    }),
    // Charge la langue par defaut avant le premier rendu : sans cela, un
    // translate() appele a l'initialisation de la premiere page affichee rend
    // la cle brute. Un echec de chargement ne doit pas bloquer le demarrage :
    // mieux vaut des cles brutes qu'un ecran blanc.
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [TranslocoService],
      useFactory: (transloco: TranslocoService) => () =>
        firstValueFrom(transloco.load(tenantConfig.locale.default_language)).catch(err => console.error(err)),
    },
  ],
})
export class TranslocoRootModule {}
